import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageMeta from '@/components/PageMeta';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageMeta title="Page not found" path="/404" description="The page you're looking for doesn't exist on OrangeLabel.io." />
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="mb-8 sm:mb-12">
          <h1 className="text-2xl sm:text-3xl md:text-4xl tracking-tight font-bold font-heading text-foreground mb-3 sm:mb-4" data-testid="notfound-heading">
            Page not found
          </h1>
          <p className="text-base sm:text-lg text-muted-foreground">
            The page you're looking for doesn't exist or may have moved.
          </p>
        </div>

        <div className="prose max-w-none space-y-6 sm:space-y-8">
          <div className="bg-muted border border-border rounded-xl p-5 sm:p-8">
            <h2 className="text-xl sm:text-2xl font-heading font-semibold text-foreground mb-3 sm:mb-4">Where to go next</h2>
            <div className="flex flex-wrap gap-3 sm:gap-4">
              <Link
                to="/"
                className="inline-block bg-primary text-white hover:bg-primary-hover rounded-full px-6 sm:px-8 py-2.5 sm:py-3 font-semibold transition-all shadow-sm hover:shadow-md text-sm sm:text-base"
                data-testid="notfound-home-link"
              >
                Home
              </Link>
              <Link
                to="/map"
                className="inline-block bg-card border border-border text-foreground hover:bg-accent rounded-full px-6 sm:px-8 py-2.5 sm:py-3 font-semibold transition-all text-sm sm:text-base"
                data-testid="notfound-map-link"
              >
                Map
              </Link>
              <Link
                to="/directory"
                className="inline-block bg-card border border-border text-foreground hover:bg-accent rounded-full px-6 sm:px-8 py-2.5 sm:py-3 font-semibold transition-all text-sm sm:text-base"
                data-testid="notfound-directory-link"
              >
                Directory
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
